// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3nR-M","colBig":"styles_colBig__3IxA6","colSmall":"styles_colSmall__e1dr2"};